<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.products.name') }}</h2>
                        <p class="card-description">{{ $t('names.products.description') }}</p>
                        <b-button variant="primary" class="mt-4 mb-4" @click="$router.push('/product/new')">{{ $t('createNewTitle') }}</b-button>
                        <b-table striped hover :items="items" :fields="fields" @row-clicked="editItem" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../config'

    export default {
        name: 'ProductItemList',
        data() {
            return {
                items: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                        thStyle: 'width: 75px;'
                    },
                    {
                        key: 'name',
                        label: this.$t('forms.name'),
                        sortable: true
                    },
                    {
                        key: 'category.name',
                        label: this.$t('forms.category'),
                        sortable: true
                    },
                    {
                        key: 'url',
                        label: 'URL',
                        sortable: false
                    },
                    {
                        key: 'itemOrder',
                        label: this.$t('forms.order'),
                        sortable: true,
                        thStyle: 'width: 220px;'
                    }
                ]
            }
        },
        mounted() {
            axios.get(Const.API_HOST + '/admin/productItems')
                .then(response => response.data).then(body => {
                this.items = body
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            })
        },
        methods: {
            editItem(item) {
                this.$router.push('/product/edit/' + item.id)
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

</style>
